/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Modal_Select_CategoryInputs */

const es_feedback_modal_select_category = /** @type {(inputs: Feedback_Modal_Select_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona una categoría`)
};

const en_feedback_modal_select_category = /** @type {(inputs: Feedback_Modal_Select_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a category`)
};

/**
* | output |
* | --- |
* | "Select a category" |
*
* @param {Feedback_Modal_Select_CategoryInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const feedback_modal_select_category = /** @type {((inputs?: Feedback_Modal_Select_CategoryInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Modal_Select_CategoryInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_feedback_modal_select_category(inputs)
	return en_feedback_modal_select_category(inputs)
});
export { feedback_modal_select_category as "feedback.modal.select_category" }